// Thin wrapper over /api/canvaselements - mirrors notesApi.js/blockMarkersApi.js
// exactly (bare scalar ids in request bodies, full nested objects in GET
// responses - same backend author, same convention).

import axios from 'axios';

const jsonHeaders = {
   withCredentials: true,
   headers: { 'Content-Type': 'application/json' },
};

export function getCanvasElements(workspaceId, topicId) {
   return axios.get('/api/canvaselements?workspace=' + workspaceId + '&topic=' + topicId, { withCredentials: true });
}

export function createCanvasElement(payload) {
   return axios.post('/api/canvaselements', JSON.stringify(payload), jsonHeaders);
}

export function updateCanvasElement(id, payload) {
   return axios.put('/api/canvaselements/' + id, JSON.stringify(payload), jsonHeaders);
}

export function deleteCanvasElement(id) {
   return axios.delete('/api/canvaselements/' + id, { withCredentials: true });
}

// Same upload convention as MediaUploader.jsx (src/components/MediaUploader.jsx) -
// FormData + axios, backend returns a File entity, caller builds the
// fetchable URL itself as /api/files/{id}/content. workspaceId is required by
// CanvasMediaController (@RequestParam, no default) - it's stored as the
// File's owner id so a student's own upload stays readable back through
// /platform-api/files/{id}/content (see PlatformCourseAccessService's
// "canvas" access-check branch). Without it every upload 400s before it
// even reaches the controller body.
export function uploadCanvasImage(file, workspaceId, onUploadProgress) {
   const formData = new FormData();
   formData.append('file', file);
   formData.append('workspaceId', workspaceId);
   return axios.post('/api/canvaselements/media', formData, { withCredentials: true, onUploadProgress });
}

export function canvasFileUrl(fileMeta) {
   return '/api/files/' + fileMeta.id + '/content';
}
